module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('p', {
    staticClass: "toc-title"
  }, [_c('img', {
    staticStyle: {
      "height": "1.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg6_1.jpg"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Contents")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "1.5em"
    },
    attrs: {
      "alt": "image",
      "src": "images/pg6_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction: Hey There!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec1"
    }
  }, [_vm._v("Week 1: Embrace Your Identity in God")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec2"
    }
  }, [_vm._v("Week 2: Build Self-Worth and Confidence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec3"
    }
  }, [_vm._v("Week 3: Navigate Friendships Gracefully")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec4"
    }
  }, [_vm._v("Week 4: Cultivate a Strong Prayer Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec5"
    }
  }, [_vm._v("Week 5: Discover Your Spiritual Gifts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec6"
    }
  }, [_vm._v("Week 6: Overcome Fear and Anxiety")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec7"
    }
  }, [_vm._v("Week 7: Embrace the Power of Forgiveness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec8"
    }
  }, [_vm._v("Week 8: Develop a Servant’s Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 9: Honor Your Parents and Guardians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 10: Manage Stress and Time")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 11: Build Healthy Relationships")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 12: Find Your Purpose and Calling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 13: Balance School, Work, and Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 14: Make Wise Choices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 15: Cultivate Gratitude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 16: Grow in Your Faith Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 17: Understand God’s Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 18: Live with Integrity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 19: Encourage Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 20: Be a Light in the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 21: Practice Contentment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 22: Deal with Doubt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 23: Set Boundaries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 24: Overcome Temptation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 25: Learn from the Strength and Faith of Esther")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 26: Develop a Heart for Worship")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 27: Practice Patience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 28: Prioritize Spiritual Growth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 29: Trust in God’s Timing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 30: Learn from Mistakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 31: Stay Connected to God’s Love")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 32: Embrace Change")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 33: Lean on God in Times of Need")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 34: Pursue a Life of Humility")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 35: Cultivate a Heart of Compassion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 36: Strengthen Your Faith Community")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 37: Be a Good Steward")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 38: Let Go of Control")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 39: Walk in Obedience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 40: Live Out Your Faith Boldly")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 41: Find Joy in the Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 42: Embrace Rest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 43: Pray for Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 44: Build Unity in Diversity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 45: Learn to Listen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 46: Overcome Discouragement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 47: Stand Firm in Your Convictions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 48: Believe in the Power of Testimony")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 49: Share Your Faith with Others")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 50: Invest in Eternity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 51: Celebrate God’s Faithfulness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#sec52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Week 52: Step into Your Future with Confidence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: What a Ride It’s Been!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/aboutauthor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg8_1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0